"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DomestikaLiveCardSkeleton = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _FeaturedLiveSkeleton = require("./FeaturedLiveSkeleton");

var _CompleteLiveSkeleton = require("./CompleteLiveSkeleton");

var _BasicLiveSkeleton = require("./BasicLiveSkeleton");

var _Layout = require("../Layout");

var LiveCardSkeletonTypes = {
  featured: function featured(props) {
    return _react.default.createElement(_FeaturedLiveSkeleton.FeaturedLiveSkeleton, props);
  },
  complete: function complete(props) {
    return _react.default.createElement(_CompleteLiveSkeleton.CompleteLiveSkeleton, props);
  },
  basic: function basic(props) {
    return _react.default.createElement(_BasicLiveSkeleton.BasicLiveSkeleton, props);
  }
};

var DomestikaLiveCardSkeleton = function DomestikaLiveCardSkeleton(_ref) {
  var type = _ref.type,
      props = (0, _objectWithoutProperties2.default)(_ref, ["type"]);
  return _react.default.createElement(_Layout.Flex, {
    flexDirection: "column",
    minHeight: "100%",
    width: "100%"
  }, LiveCardSkeletonTypes[type](props));
};

exports.DomestikaLiveCardSkeleton = DomestikaLiveCardSkeleton;
DomestikaLiveCardSkeleton.defaultProps = {
  color: 'durian',
  type: 'complete'
};